// Vue
import { defineStore } from 'pinia';

// common
import i18n from '@/common/i18n';

// Repository
import MonthlyReportRepository from '@/repositories/monthlyReportRepository';
import ManagementRepository from '@/repositories/managementRepository';

// commonProject
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

// Model
import { OrganizationIsuResponce } from '@/models/management/managementModel';

import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useMonthlyReportStore = defineStore({
    id: 'monthlyReport',
    state: () => ({
        // 組織セレクトボックス内容
        organization: [],
        // 表示期間セレクトボックス内容
        monthsPeriod: [],
        // 月次レポート（利用者）用リスト
        userList: [],
        // 月次レポート（利用実績）初回利用人数
        firstUserList: [],
        // 月次レポート（利用実績）利用件数/人数（相談方法）（従業員）
        workerList: [],
        // 月次レポート（利用実績）利用件数（相談方法）（家族）
        familyList: [],
        // 月次レポート（利用実績）「性別利用人数」
        genderList: [],
        // 月次レポート（利用実績）「年齢別利用人数」
        ageList: [],
        // 月次レポート（利用実績）「組織別利用人数」
        organizationList: [],
        // 月次レポート（利用実績）「職位別利用人数」
        positionList: [],
        // 月次レポート（利用実績）「勤続年数種別利用人数」
        serviceLengthList: [],
        // 月次レポート（利用実績）「職種別利用人数」
        jobCategoryList: [],
        // 月次レポート（利用実績）「高ストレス者」
        highStressList: [],
        // 月次レポート（利用実績）「自由登録」
        selfSignupList: [],
        // 月次レポート（イシュー分類別）
        issueClassList: [],
        // 月次レポート（イシュー別）
        issueList: [],
        // 月次レポート（イシュー別）高ストレス者
        issueHighStressList: [],
        // 月次レポート（イシュー別）性別 × 相談内容
        genderIssueList: [],
        // 月次レポート（リファー先）
        referList: [],
        // 月次レポート（現況把握回答）
        understandList: [],
        // 月次レポート（アンケート回答）
        questionList: [],
    }),
    getters: {},
    actions: {
        reset() {
            this.userList = [];
            this.firstUserList = [];
            this.workerList = [];
            this.familyList = [];
            this.genderList = [];
            this.ageList = [];
            this.organizationList = [];
            this.positionList = [];
            this.serviceLengthList = [];
            this.jobCategoryList = [];
            this.highStressList = [];
            this.selfSignupList = [];
            this.issueClassList = [];
            this.issueList = [];
            this.issueHighStressList = [];
            this.genderIssueList = [];
            this.referList = [];
            this.understandList = [];
            this.questionList = [];
        },
        /**
         * 組織選択処理
         */
        async getOrgSelAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const managementRepository = new ManagementRepository();
            try {
                const response = await managementRepository.getOrgSelActionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.organization = response.data.List.filter((item) => item.MonRepFlag).map((item) => OrganizationIsuResponce.formApiResponse(item));
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート期間取得API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportPeriodAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportPeriodApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.monthsPeriod = response.data.Months;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート表示可否確認API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportCheckAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportCheckApi(API_URL, requestBody, idToken);
                // 本機能では例外エラーを設定しないこと。
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（利用者）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportCliantAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportCliantApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.userList = response.data.Values;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（利用実績1）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportConfigAction(API_URL, queryParam, identifier) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportConfigApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                switch (identifier) {
                    case 'firstUser':
                        this.firstUserList = response.data.Months;
                        break;
                    case 'worker':
                        this.workerList = response.data.Months;
                        break;
                    case 'family':
                        this.familyList = response.data.Months;
                        break;
                    case 'highStress':
                        this.highStressList = response.data.Months;
                        break;
                    case 'selfSignup':
                        this.selfSignupList = response.data.Months;
                        break;
                    default:
                        break;
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（利用実績2）API
         * グルーピングを行う。
         * データの結果が15人以下の場合は負の値が入る。
         * @param {*} requestBody
         * @returns response
         */
        async getMonthlyReportUseAction(API_URL, requestBody, identifier) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportUseApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                switch (identifier) {
                    case 'gender':
                        this.genderList = response.data.Values;
                        break;
                    case 'age':
                        this.ageList = response.data.Values;
                        break;
                    case 'organization':
                        this.organizationList = response.data.Values;
                        break;
                    case 'position':
                        this.positionList = response.data.Values;
                        break;
                    case 'serviceLength':
                        this.serviceLengthList = response.data.Values;
                        break;
                    case 'jobCategory':
                        this.jobCategoryList = response.data.Values;
                        break;
                    default:
                        break;
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（イシュー分類別）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportIssueClassAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportIssueClassApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.issueClassList = response.data.Values;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（イシュー別）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportIssueAction(API_URL, queryParam, identifier) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportIssueApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                switch (identifier) {
                    case 'issue':
                        this.issueList = response.data.Values;
                        break;
                    case 'issueHighStress':
                        this.issueHighStressList = response.data.Values;
                        break;
                    case 'genderIssue':
                        this.genderIssueList = response.data.Values;
                        break;
                    default:
                        break;
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（リファー先）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportReferAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportReferApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.referList = response.data.Values;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（現況把握回答）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportUnderstandAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportUnderstandApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.understandList = response.data.Values;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 月次レポート（アンケート回答）API
         * @param {*} queryParam
         * @returns response
         */
        async getMonthlyReportQuestionAction(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const monthlyReportRepository = new MonthlyReportRepository();
            try {
                const response = await monthlyReportRepository.getMonthlyReportQuestionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.questionList = response.data.Values;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
